export default function initAddToCartToast() {
    // Listen for the WooCommerce custom event
    document.removeEventListener('added_to_cart', handleAddToCartToast);
    document.addEventListener('added_to_cart', handleAddToCartToast);

    function handleAddToCartToast() {
        Swal.fire({
            icon: 'success',
            title: 'Item added to cart!',
            toast: true,
            position: window.innerWidth < 768 ? 'center' : 'top-end',
            showConfirmButton: true,
            confirmButtonText: 'View Cart',
            confirmButtonColor: '#b20b12',
            showCancelButton: true,
            cancelButtonText: 'Continue Shopping',
            cancelButtonColor: '#111111',
            timer: false
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = wc_add_to_cart_params.cart_url;
            }
        });
    }
}
